(function () {
  function syncMobileViewportVars() {
    const viewport = window.visualViewport;
    const height = viewport ? viewport.height : window.innerHeight;
    const bottom = viewport
      ? Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop)
      : 0;

    document.documentElement.style.setProperty('--belov-mobile-vh', `${height}px`);
    document.documentElement.style.setProperty('--belov-mobile-bottom', `${bottom}px`);
  }

  let viewportRaf = null;
  function requestMobileViewportSync() {
    if (viewportRaf) return;
    viewportRaf = window.requestAnimationFrame(() => {
      viewportRaf = null;
      syncMobileViewportVars();
    });
  }

  syncMobileViewportVars();
  window.addEventListener('resize', requestMobileViewportSync, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', requestMobileViewportSync, { passive: true });
    window.visualViewport.addEventListener('scroll', requestMobileViewportSync, { passive: true });
  }
})();

(function () {
  const pills = document.querySelectorAll('.bulk-quantity-pill');
  const form = document.querySelector('form[action$="/cart/add"]');

  if (!form || !pills.length) return;

  const quantityInput = form.querySelector('input[name="quantity"]');

  const firstPillValue = pills[0].getAttribute('data-quantity-value');
  pills[0].classList.add('active');
  if (quantityInput) {
    quantityInput.value = firstPillValue;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  pills.forEach((pill) => {
    pill.addEventListener('click', function () {
      const value = this.getAttribute('data-quantity-value');

      // Update the quantity input
      if (quantityInput) {
        quantityInput.value = value;
        // Trigger change event for any listeners
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Update active state on pills
      pills.forEach((p) => p.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // Sync pills when quantity input changes manually
  if (quantityInput) {
    quantityInput.addEventListener('change', function () {
      const currentVal = this.value;
      pills.forEach((pill) => {
        if (pill.getAttribute('data-quantity-value') === currentVal) {
          pill.classList.add('active');
        } else {
          pill.classList.remove('active');
        }
      });
    });
  }
})();

/* swiper.js init for UGC in testimonials.liquid */
document.addEventListener('DOMContentLoaded', () => {
  // Initialize Swiper for UGC
  const ugcSwiper = new Swiper('.ugc-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 24,
    loop: true,
    centeredSlides: true,

    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    loopAdditionalSlides: 4,

    /*     breakpoints: {
      480: {
        slidesPerView: 1.2,
        spaceBetween: 16
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup:1,
        spaceBetween: 18
      },
      1024: {
        slidesPerView: 2.66,
        slidesPerGroup:1,
        spaceBetween: 18
      }
    }, */
    // Navigation arrows
    navigation: {
      nextEl: '.ugc-swiper-button-next',
      prevEl: '.ugc-swiper-button-prev',
    },
  });
});

/* swiper.js init for featured ingredients in product_featured-ingredients.liquid */
document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(max-width: 767px)');
  let ingredientsSwiper = null;

  function initIngredientsSwiper() {
    if (mq.matches && !ingredientsSwiper && document.querySelector('.ingredients-swiper')) {
      ingredientsSwiper = new Swiper('.ingredients-swiper', {
        slidesPerView: 1.4,
        spaceBetween: 16,
        grabCursor: true,
        slidesOffsetAfter: 40,
        pagination: {
          el: '.ingredients-swiper .swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.ingredients-swiper .swiper-button-next',
          prevEl: '.ingredients-swiper .swiper-button-prev',
        },
      });
    }
  }

  initIngredientsSwiper();
  mq.addEventListener('change', initIngredientsSwiper);
});

/* swiper.js init for bundle upsell modal — deferred until first open.
   Swiper construction is skipped entirely on pages where the modal is never
   opened, saving the layout-measurement work on every page load. */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-bundle-swiper]').forEach((el) => {
    const modal = el.closest('.modal__content');
    const modalRoot = el.closest('.modal');
    if (!modal || !modalRoot) return;

    let swiper = null;

    function initSwiper() {
      // Cards have a fixed CSS width. slidesPerView:'auto' reads that width and
      // watchOverflow keeps the swiper locked (static, centered, no controls)
      // while all cards fit in a single row.
      // NOTE: bundled Swiper is 4.3 — breakpoints keys are MAX-width (the
      // opposite of Swiper 5+), so base config is tablet/desktop and 767 is mobile.
      swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        grabCursor: true,
        observer: true,
        observeParents: true,
        watchOverflow: true,
        centerInsufficientSlides: true,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        breakpoints: {
          // Mobile (<=767px): modal drops its side gutter, so offset the snap
          // grid so every slide snaps flush to the gutter instead of the edge.
          767: {
            spaceBetween: 16,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
          },
        },
        pagination: {
          el: modal.querySelector('.bundle-upsell-pagination'),
          clickable: true,
        },
        navigation: {
          prevEl: modal.querySelector('.bundle-upsell-nav-prev'),
          nextEl: modal.querySelector('.bundle-upsell-nav-next'),
        },
      });
    }

    function refresh() {
      if (!el.clientWidth) return;
      swiper.update();
      const overflows = el.scrollWidth > el.clientWidth + 1;
      modal.classList.toggle('bundle-upsell--scrollable', overflows);
    }

    // Watch for modal activation; initialize Swiper on first open only.
    const mo = new MutationObserver(() => {
      if (!modalRoot.classList.contains('modal--active')) return;
      if (!swiper) initSwiper();
      requestAnimationFrame(refresh);
    });
    mo.observe(modalRoot, { attributes: true, attributeFilter: ['class'] });

    // Shopify Theme Editor re-renders sections by removing and replacing the DOM.
    // Disconnect the observer on section unload so the detached modal subtree can
    // be garbage-collected instead of being held alive by the observer reference.
    document.addEventListener('shopify:section:unload', (e) => {
      if (modalRoot.closest(`[id^="shopify-section-"]`) === e.target || e.target.contains(modalRoot)) {
        mo.disconnect();
      }
    });

    window.addEventListener('resize', () => {
      if (swiper && modalRoot.classList.contains('modal--active')) refresh();
    });
  });
});

/* swiper.js init for the inline bundle-cards landing feature.
   Same card behavior as the modal upsell, but the section is always visible so
   it initializes immediately on load (no modal-activation gate). Controls are
   resolved within each .bundle-feature wrapper so multiple section instances on
   one page don't collide. */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-bundle-feature-swiper]').forEach((el) => {
    const root = el.closest('.bundle-feature');
    if (!root) return;

    // Single slidesPerView:'auto' config for every breakpoint — slide widths are
    // driven by CSS (4-up that fills the row at >=1280, fixed-ish cards that
    // overflow the viewport below that). Keeping it 'auto' means Swiper never
    // writes inline widths, so nothing gets stuck when crossing the breakpoint.
    // watchOverflow locks it static once all cards fit (the desktop row).
    const swiper = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      centerInsufficientSlides: true,
      pagination: {
        el: root.querySelector('.bundle-feature-pagination'),
        clickable: true,
      },
      navigation: {
        prevEl: root.querySelector('.bundle-feature-nav-prev'),
        nextEl: root.querySelector('.bundle-feature-nav-next'),
      },
    });

    // Page gutter = the inset of .container--large (where the heading/content
    // starts). Used as the carousel's start/end snap offset so the first/last
    // card line up with the page content edge while the track is full-bleed.
    function gutterPx() {
      const vw = document.documentElement.clientWidth;
      if (vw <= 767) return 20; // container--large: width 100% + 20px padding
      return Math.max(0, (vw - Math.min(vw * 0.9, 1160)) / 2); // width 90%, max 1160
    }

    function refresh() {
      if (!el.clientWidth) return;
      // isLocked = all cards fit (the static desktop row) → no snap offset and
      // hide the carousel controls. Otherwise it's a carousel → inset the snap
      // grid by the page gutter and show the controls.
      const carousel = !swiper.isLocked;
      const offset = carousel ? gutterPx() : 0;
      swiper.params.slidesOffsetBefore = offset;
      swiper.params.slidesOffsetAfter = offset;
      swiper.update();
      root.classList.toggle('bundle-feature--scrollable', carousel);
    }

    requestAnimationFrame(refresh);
    window.addEventListener('resize', refresh);
  });
});

/* tabs handler */
function initTabs(root = document) {
  root.querySelectorAll('[data-tabs-menu]').forEach((menu) => {
    const id = menu.dataset.tabsMenu;
    const pane = root.querySelector(`[data-tabs-pane="${id}"]`);
    if (!pane) return;

    const buttons = [...menu.children];
    const panels = [...pane.children];

    function activate(index) {
      buttons.forEach((btn, i) => btn.classList.toggle('is-active', i === index));
      panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index));
      menu.dispatchEvent(new CustomEvent('tabs:change', { bubbles: true, detail: { index } }));
    }

    buttons.forEach((btn, i) => btn.addEventListener('click', () => activate(i)));

    activate(0);
  });
}

initTabs();

// modals + cart-drawer scroll lock
// Reference-counted: each caller (cart drawer, each modal) holds one count.
// The body stays fixed as long as any count is held; actual lock/unlock only
// happen on the 0→1 and 1→0 transitions respectively.
var _scrollLockCount = 0;
var _scrollY = 0;

function lockScroll() {
  if (_scrollLockCount === 0) {
    _scrollY = window.scrollY;
    document.body.style.top = `-${_scrollY}px`;
    document.body.classList.add('scroll-locked');
  }
  _scrollLockCount++;
}

function unlockScroll() {
  if (_scrollLockCount <= 0) return;
  _scrollLockCount--;
  if (_scrollLockCount === 0) {
    document.body.classList.remove('scroll-locked');
    document.body.style.top = '';
    window.scrollTo({ top: _scrollY, behavior: 'instant' });
  }
}

var _lastFocusedBeforeModal = null;

function trapModalFocus(e, modal) {
  var sel = 'a[href], button:not([disabled]), input:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])';
  var focusables = Array.from(modal.querySelectorAll(sel)).filter((el) => el.offsetParent !== null);
  if (!focusables.length) return;
  var first = focusables[0], last = focusables[focusables.length - 1];
  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault();
    last.focus();
  } else if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault();
    first.focus();
  }
}

function openModal(id) {
  var modal = document.querySelector(`[data-modal-target="${id}"]`);
  if (!modal) return;
  _lastFocusedBeforeModal = document.activeElement;
  // If another modal is already open, swap it out without touching the lock count
  // (the outgoing modal's count stays balanced by the incoming one).
  // If no modal is open, acquire a fresh lock — which is a no-op when the cart
  // drawer is already holding one (count goes 1→2, body stays fixed, _scrollY intact).
  var existing = document.querySelector('.modal.modal--active');
  if (existing) {
    existing.classList.remove('modal--active');
    existing.setAttribute('aria-hidden', 'true');
  } else {
    lockScroll();
  }
  modal.classList.add('modal--active');
  modal.setAttribute('aria-hidden', 'false');
  requestAnimationFrame(() => {
    var firstFocusable = Array.from(
      modal.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])',
      ),
    ).find((el) => el.offsetParent !== null);
    if (firstFocusable) firstFocusable.focus();
  });
}

function closeModal(id) {
  var modal = document.querySelector(`[data-modal-target="${id}"]`);
  if (!modal || !modal.classList.contains('modal--active')) return;
  modal.classList.remove('modal--active');
  modal.setAttribute('aria-hidden', 'true');
  unlockScroll();
  if (_lastFocusedBeforeModal && typeof _lastFocusedBeforeModal.focus === 'function') {
    _lastFocusedBeforeModal.focus();
    _lastFocusedBeforeModal = null;
  }
}

function closeAllModals() {
  var hadActive = !!document.querySelector('.modal.modal--active');
  document.querySelectorAll('.modal.modal--active').forEach((modal) => {
    modal.classList.remove('modal--active');
    modal.setAttribute('aria-hidden', 'true');
  });
  if (hadActive) unlockScroll();
}

document
  .querySelectorAll('[data-modal-target].modal')
  .forEach((el) => document.body.appendChild(el));

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-modal-trigger]');
  if (trigger) {
    openModal(trigger.getAttribute('data-modal-trigger'));
    return;
  }

  const closer = e.target.closest('[data-modal-close]');
  if (closer) {
    closeModal(closer.getAttribute('data-modal-close'));
  }
});

document.addEventListener('keydown', (e) => {
  const activeModal = document.querySelector('.modal.modal--active');
  if (!activeModal) return;
  if (e.key === 'Escape') {
    closeModal(activeModal.getAttribute('data-modal-target'));
    return;
  }
  if (e.key === 'Tab') {
    trapModalFocus(e, activeModal);
  }
});
// end of modals handler

// ATC dynamic price display
(function () {
  const form = document.querySelector('form[action$="/cart/add"]');
  if (!form) return;

  const btn = form.querySelector('.is-atc');
  const qtyInput = form.querySelector('input[name="quantity"]');
  const variantSelect = form.querySelector('select.original-selector');

  if (!btn || !qtyInput) return;

  const moneyFormat = btn.dataset.moneyFormat || '${{amount}}';

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
  }

  function priceSuffix() {
    const qty = parseInt(qtyInput.value) || 1;
    const unitPrice = parseInt(btn.dataset.unitPrice) || 0;
    return unitPrice > 0 ? ' • ' + formatMoney(unitPrice * qty) : '';
  }

  // theme.js (_.updateButtons → _._updateButtonText) rewrites the button's
  // innerHTML with $button.html(label) on load and on every variant change,
  // which deletes any price node we add. So we own the price <span> and
  // re-attach it whenever the button content changes — but only while the
  // button is in its active "add to cart" state (theme adds [disabled] for
  // sold-out / no-variant and a .confirmation class during the adding/added
  // animation, where a price would be wrong).
  function syncPrice() {
    if (btn.hasAttribute('disabled') || btn.classList.contains('confirmation')) return;
    let priceEl = btn.querySelector('.atc-btn__price');
    if (!priceEl) {
      priceEl = document.createElement('span');
      priceEl.className = 'atc-btn__price';
      btn.appendChild(priceEl);
    }
    priceEl.textContent = priceSuffix();
  }

  // Re-apply after the theme rewrites the label or toggles state.
  // Appending the span re-fires the observer, but the guard above + the
  // "already present" check make that a no-op, so there is no loop.
  const observer = new MutationObserver(syncPrice);
  observer.observe(btn, {
    childList: true,
    attributes: true,
    attributeFilter: ['disabled', 'class'],
  });

  // qty input change covers both manual edits and pill clicks (pills dispatch 'change')
  qtyInput.addEventListener('change', syncPrice);

  // on variant switch, pull new price from the product JSON blob already on the page
  if (variantSelect) {
    const productJsonEl = document.querySelector('[id^="cc-product-json-"]');
    const product = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;

    variantSelect.addEventListener('change', function () {
      if (!product) return;
      const variant = product.variants.find((v) => v.id === parseInt(this.value));
      if (variant) {
        btn.dataset.unitPrice = variant.price;
        syncPrice();
      }
    });
  }

  syncPrice(); // initialise on page load
})();
